import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import validatorIsURL from 'validator/lib/isURL'

export const isValidUrl = (url: string): boolean => {
  const length = url.length
  const str1 = url.substring(0, length / 2)
  const str2 = url.substring(length / 2, length)
  const isUrlDoubleCopy = str1 === str2
  const isValid = validatorIsURL(url, { allow_underscores: true }) && !isUrlDoubleCopy
  if (!isValid) fireAnalyticsEvent('Invalid_URL', { value: url })
  return isValid
}
